import ApiService from "@/common/api.service"

export const CertificateReasonService = {
    create(params) {
        return ApiService.post("certificateReasons/add", params);
    },
    update(slug, params) {
        return ApiService.update("certificateReasons", slug, params);
    },

}